import {HttpErrorResponse} from '@angular/common/http';
import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatFormField} from '@angular/material/form-field';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {FabTableState, filterStateChange, process} from '@fabric/components/table-filter/data-query';
import {catchError, forkJoin, concat, map, Observable, ObservableInput, of} from 'rxjs';
import {ErrorCodes} from 'src/app/constants/ErrorCodes';
import {UserFunctionCode} from 'src/app/constants/UserFunctionCode';
import {TransporteService} from 'src/app/services/transporte.service';
import {Transporte} from '../../models/Transporte';
import {NotificationService} from '../../services/notification.service';
import {SecurityService} from '../../services/security.service';
import {
  FabDateFilterOperator,
  RemDateFilterComponent
} from '../../shared-components/table-filter/date-filter/date-filter.component';
import {RemNumberFilterComponent} from '../../shared-components/table-filter/number-filter/number-filter.component';
import {
  FabStringFilterOperator,
  RemStringFilterComponent
} from '../../shared-components/table-filter/string-filter/string-filter.component';
import { DestinoTransportistasService } from 'src/app/services/destinoTransportista.service';

export interface Balanza {
  value: string;
  valueType: string;
}

@Component({
  selector: 'app-logistic-provider-maintenance',
  templateUrl: './transporte-maintenance.component.html',
  styleUrls: ['./transporte-maintenance.component.scss']
})
export class TransporteMaintenanceComponent implements OnInit {

  columnsToDisplay: string[] = ["codTransp", "nombreTransp", "domicilio", "localidad", "codProvincia",
    "codPostal", "cuit", "codInscripcion", "estado", "fecCreacion", "usrCreacion",
    "fecModif", "usrModif", "isEdit"]
  dataSource: MatTableDataSource<Transporte> = new MatTableDataSource<Transporte>();
  apiEndpoint = "http://localhost:8080/"
  rowsToModify: any = [];
  rowsToAdd: any = [];
  TABLE_DATA: Transporte[] = [];
  ORIGINAL_TABLE_DATA: Transporte[] = [];
  activeRelationCodTransportes: String[] = [];
  columnsSchema: any = this.columnsToDisplay;
  operators: FabStringFilterOperator[] = ['contains'];
  dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  canAddOrEdit: boolean = false;
  initialDate: string = new Date().toISOString();
  resultsLength = 0;
  pageSize = 10;
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };
  selector: string

  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort!: MatSort;
  @ViewChildren('tableFilter') tableFilters: QueryList<RemStringFilterComponent | RemNumberFilterComponent | RemDateFilterComponent>;


  public get saveButtonDisabled() {

    return !this.validateAllRows()
      || (!this.hasDataChanged()
        && this.TABLE_DATA.filter(element => element.isAdd).length == 0);
  }

  private hasDataChanged() {
    return this.TABLE_DATA.filter(element => element.isEdit).map((row) => {
      return this.isDirtyRow(row);
    }).some(item => item);

  }

  public isDirtyAndNotAdd(row: Transporte, column: string) {
    var toReturn;

    if (row.isAdd) {
      toReturn = false;
    } else {

      // @ts-ignore
      toReturn = (row[column] != row.originalData[column])
    }
    return toReturn;
  }

  public isDirty(row: Transporte, column: string) {
    // @ts-ignore
    return (row[column] != row.originalData[column]);

  }


  constructor(private transporteService: TransporteService,
              private destinoTransportistasService: DestinoTransportistasService,
              private notificationService: NotificationService,
              private securityService: SecurityService,
              private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.fetchData();
    this.canAddOrEdit = this.securityService.can(UserFunctionCode.MAINTENANCE);
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.processData;
  }

  public filterChange(event: any) {
    this.state.skip = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.processData();
  }

  getDestinoTransportistaRelations() {
    this.destinoTransportistasService.getDistinctTransporte().subscribe(
      (data: String[]) => {
        this.activeRelationCodTransportes = data;
      },
      (err: string) => {
        this.notificationService.open(err, 'error');
      }
    )
  }


// process your local data and assign it to the datasource
// <your data> is an array of objects whose keys match up to the table columns
  private fetchData() {
    this.getDestinoTransportistaRelations();
    this.transporteService.getTransporteTable().subscribe(
      (data: any) => {

        this.dataSource.data = process(data as any[], this.state)
        for (const row of this.dataSource.data) {
          row.isEdit = false;
          row.isAdd = false;
          row.isSave = false;
          row.originalData = JSON.parse(JSON.stringify(row));
        }
        this.TABLE_DATA = data as any[];

        this.TABLE_DATA = this.TABLE_DATA.filter((item) => {
          return item.estado !== false

        })


        this.sortTableById();
        this.processData();

      },
      (err: string) => {
        this.notificationService.open(err, 'error');
      }
    )
  }


  processData() {
    this.dataSource.data = process(this.TABLE_DATA, this.state);
  }

  sortDataByModif() {
    this.TABLE_DATA.sort(function (a, b) {
      var va = (a.fecModif === undefined || null) ? new Date(a.fecCreacion) : new Date(a.fecModif),
        vb = (b.fecModif === undefined || null) ? new Date(b.fecCreacion) : new Date(b.fecModif);

      // @ts-ignore
      return vb - va;
    });
  }

  sortTableById() {
    this.TABLE_DATA.sort((a, b) => {
      // @ts-ignore
      return b.id - a.id;
    });
  }


  addRow() {
    console.log("add row");
    let newRow = new Transporte;
    newRow.estado = true;
    newRow.isAdd = true;
    newRow.isSave = true;
    newRow.usrCreacion = this.securityService.LOGGED_USER['gmin'];
    this.dataSource.data.unshift(newRow);

    this.processData();
  }


  editRow(row: Transporte) {
    // console.log("edit row");
    if (!row.isAdd) {
      row.isEdit = true;
      row.isSave = true;
      row.usrModif = this.securityService.LOGGED_USER['gmin'];
    }

    if (row.isAdd) {
      row.isEdit = true;
    }
  }


  cancelRow(row: Transporte) {

    if (row.isAdd) {
      this.TABLE_DATA = this.TABLE_DATA.filter((item) => {
        return item !== row;
      })
    } else {
      row.codTransp = row.originalData.codTransp;
      row.nombreTransp = row.originalData.nombreTransp;
      row.domicilio = row.originalData.domicilio;
      row.localidad = row.originalData.localidad;
      row.codProvincia = row.originalData.codProvincia;
      row.cuit = row.originalData.cuit;
      row.codInscripcion = row.originalData.codInscripcion;
      row.estado = row.originalData.estado;
      row.codPostal = row.originalData.codPostal;
      row.usrModif = row.originalData.usrModif;

      row.isEdit = false;
      row.isSave = false;
    }


    this.processData();
  }


  save() {
    let inactiveObservables: ObservableInput<any>[] = [];
    let activeObservables: ObservableInput<any>[] = [];
    let errors: HttpErrorResponse[] = [];
    let saved = 0;
    let firstValidation: Boolean = this.validateAllRows();
    if (firstValidation) {
      this.TABLE_DATA.filter((item) => item.isSave)
        .forEach((row) => {
            if (this.isDirtyRow(row) || row.isAdd) {
              let observableType = row.estado ? activeObservables : inactiveObservables;
              observableType.push(
                this.transporteService.addUpdateTransp(row, row.isAdd)
                  .pipe(
                    map((res: Transporte) => {
                      console.log("Response: ");
                      console.log(row);
                      console.log(res);
                      row.originalData = res;
                      row.isEdit = false;
                      row.isAdd = false;
                      row.isSave = false;
                      row.id = res.id;
                      row.fecModif = res.fecModif;
                      saved++;
                    }),
                    catchError((err: HttpErrorResponse) => {
                      errors.push(err);
                      return of(null);
                    })
                  )
              );
            } else {
              this.cancelRow(row);
            }
          }
        );

        concat(forkJoin(inactiveObservables), forkJoin(activeObservables)).subscribe({
        next: undefined,
        error: undefined,
        complete: () => {
          if (errors.length == 0) {
            this.notificationService.open(ErrorCodes.SAVED, 'success');
            this.sortTableById();
            this.processData();
          } else {
            const errorCounts = errors.map(err => err.error.errorMessage).reduce((accumulator, value) => {
              // @ts-ignore
              return {...accumulator, [value]: (accumulator[value] || 0) + 1};
            }, {});
            let errorMessage = `${saved} rows saved. ${errors.length} rows have errors:`
              .concat(...Object.entries(errorCounts).map(([msg, count]) => `\n${msg} (${count})`));
            this.notificationService.open(errorMessage, 'error');
          }
        }
      });
    } else {
        this.notificationService.open(ErrorCodes.INVALID_DATA, 'error');
    }
  }


  private validateRow(row: Transporte) {
    return /^([A-Za-z]{1,2})$/.test(row.codProvincia) &&
      /^([a-zA-Z0-9]{1,10})$/.test(row.codPostal) &&
      /^([0-9_-]{1,30})$/.test(row.cuit) &&
      /^([A-Za-z]{1,30})$/.test(row.codInscripcion) &&
      row.codTransp.length > 0 &&
      row.nombreTransp.length > 0 &&
      row.domicilio.length > 0 &&
      row.localidad.length > 0 &&
      !this.idExistsInTable(row) &&
      !this.isEstadoInactiveAndActiveRelation(row);

  }

  public validateAllRows() {
    return this.TABLE_DATA.filter(element => element.isEdit).every((row) => this.validateRow(row))
      && this.TABLE_DATA.filter(element => element.isAdd).every((row) => this.validateRow(row));
  }


  private dirtyCheck(): boolean {
    return !this.TABLE_DATA.every((row) => {
      return !row.isEdit;
    })
  }

  idExistsInTable(row: Transporte) {
    if (row.estado) {
      return this.TABLE_DATA.filter((element) => {
        return row != element &&
          row.codTransp == element.codTransp &&
          element.estado;

      }).length > 0;
    } else {
      return false;
    }
  }

  checkId(row: Transporte, control: MatFormField) {
    if (this.idExistsInTable(row)) {
      this.notificationService.open(ErrorCodes.DUPLICATE_SOLICITANTE, "warn");
      control._control.ngControl?.control?.setErrors({'id-already-exists':true});
    }
  }

  checkActiveRelation(row: Transporte, control: MatFormField){
    if(this.isEstadoInactiveAndActiveRelation(row)){
      this.notificationService.open(ErrorCodes.TRANSPORTE_RELATIONSHIP_ACTIVE, 'error');
      control._control.ngControl?.control?.setErrors({'relation-is-active':true});
    }
  }

  isEstadoInactiveAndActiveRelation(row: Transporte){
    row.isActiveRelation = this.activeRelationCodTransportes.includes(row.codTransp);
    return ((!row.estado) && row.isActiveRelation)
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.dirtyCheck()) {
      return confirm("You have unsaved changes. Leave page anyway?");
    } else {
      return true;
    }
  }


  private isDirtyRow(row: Transporte) {

    const keys = Object.keys(row) as (keyof Transporte)[];
    return keys.map((key) => {
      if (!['isSave','isEdit', 'isAdd', 'originalData', 'fecCreacion', 'usrModif', 'fecModif', 'isActiveRelation'].includes(key)) {
        let dataChanged = this.isDirtyAndNotAdd(row, key);
        return dataChanged;
      } else {
        return false;
      }
    }).some(item => item);

  }
}
